import { Monster } from './Monster';
import Phaser from 'phaser';
import { AudioManager, SoundEffect } from '../../systems/AudioManager';

export class TankAlien extends Monster {

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);
    this.health = 150;
    this.maxHealth = 150;
    this.speed = 15; // Very slow
    this.reward = 25;
    this.specialAbility = 'High Health';
    
    // Visual representation - larger, tank-like monster
    const circle = scene?.add.circle(0, 0, 12, 0x800080);
    circle.setName('monsterCircle');
    this?.add(circle);
  }


  override attackEarth(): void {
    const _this = this;
    if (!this.targetEarth || !this.scene) return;
    
    // Create heavy impact effect
    this.createHeavyAttackEffect();
    
    // Tank aliens deal more damage
    const baseDamage = 15;
    if (this.isActive) this.targetEarth.takeDamage(baseDamage);
    
    // Play attack sound
    const audioManager = AudioManager.getInstance(this.scene);
    audioManager.playSFX(SoundEffect.EARTH_DAMAGE);
    
    // Screen shake for heavy impact
    this.scene?.cameras.main.shake(150, 0.02);
    
    // Mark as inactive before destroying
    this.isActive = false;
    
    // Heavy death explosion
    this.createHeavyDeathExplosion();
    
    // Longer delay for dramatic effect
    this.scene.time.delayedCall(150, () => {
      _this.destroy();
    });
  }

  override createHeavyAttackEffect(): void {
    if (!this.scene) return;
    // Heavy impact shockwave
    const shockwave = this.scene?.add.circle(this.x, this.y, 20, 0xffffff, 0.0);
    shockwave.setStrokeStyle(4, 0xffaa00, 1.0);
    
    this.scene?.tweens?.add({
      targets: shockwave,
      scaleX: 3,
      scaleY: 3,
      alpha: 0,
      duration: 400,
      ease: 'Power2',
      onComplete: () => shockwave.destroy()
    });
    
    // Heavy impact crater effect
    const crater = this.scene?.add.circle(this.x, this.y, 12, 0x444444, 0.6);
    this.scene?.tweens?.add({
      targets: crater,
      alpha: 0.2,
      duration: 1000,
      onComplete: () => crater.destroy()
    });
    
    // Debris particles
    for (let i = 0; i < 10; i++) {
      const angle = (Math.PI * 2 * i) / 10;
      const debris = this.scene?.add.rectangle(this.x, this.y, 2, 2, 0x666666);
      
      this.scene?.tweens?.add({
        targets: debris,
        x: this.x + Math.cos(angle) * 30,
        y: this.y + Math.sin(angle) * 30 - 15,
        rotation: Math.random() * Math.PI * 2,
        alpha: 0,
        duration: 600,
        ease: 'Power2',
        onComplete: () => debris.destroy()
      });
    }
  }

  override createHeavyDeathExplosion(): void {
    if (!this.scene) return;
    // Large orange explosion for tank
    const explosion = this.scene?.add.circle(this.x, this.y, 12, 0xff6600, 0.9);
    this.scene?.tweens?.add({
      targets: explosion,
      scaleX: 3,
      scaleY: 3,
      alpha: 0,
      duration: 400,
      ease: 'Power2',
      onComplete: () => explosion.destroy()
    });
    
    // Secondary explosion
    this.scene.time.delayedCall(100, () => {
      const secondExplosion = this.scene?.add.circle(this.x, this.y, 8, 0xffaa00, 0.7);
      this.scene?.tweens?.add({
        targets: secondExplosion,
        scaleX: 2,
        scaleY: 2,
        alpha: 0,
        duration: 300,
        ease: 'Power2',
        onComplete: () => secondExplosion.destroy()
      });
    });
  }

  override activateAbility(): void {
    // Tank alien has high health as passive ability
  }

  override takeDamage(amount: number): void {
    super.takeDamage(amount);
    
    // Visual feedback - change color temporarily
    const originalColor = 0x800080;
    const flashColor = 0xffffff;
    
    // Find the circle visual and change its color
    const circle = this.getByName('monsterCircle');
    if (circle instanceof Phaser.GameObjects.Arc) {
      circle.setFillStyle(flashColor);
      
      // Restore original color after 100ms
      this.scene.time.delayedCall(100, () => {
        circle.setFillStyle(originalColor);
      });
    } else if (circle instanceof Phaser.GameObjects.Graphics) {
      circle.clear();
      circle.fillStyle(flashColor);
      this.scene?.time.delayedCall(100, () => {
        circle.fillStyle(originalColor);
      });
    }
  }
} 